module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-aus-ed1a5806b22fdc5ed733ea0c7988a832.svg";